<template>
  <section class="fair-header">

    <div class="header-info">
      <div class="header-info__flex">
        <div>
          <h1 class="header-title">{{ fair.displayName }}</h1>
        <time v-if="fair.duration !== undefined"
          >{{ $d(new Date(fair.duration.start), 'L') }} -
          {{ $d(new Date(fair.duration.end), 'L') }}</time
        >
        </div>
        <div class="header-logo">
          <img :src="getLogoUrl()" />
        </div>
      </div>
      <div v-if="(booth.placeNum || booth.standnummer) && !minimized" class="header-stand">
        <div
          class="o-grid o-grid--small-full o-grid--medium-full o-grid--large-full o-grid--wrap"
          v-if="boothAddress.data !== undefined"
        >
          <div class="o-grid__cell" style="padding-left: 0">
            <div class="address">
              <div class="bold">{{ $t('fair.header.boothDetail.address') }}:</div>
              <div>{{ boothAddress.data.firma1 }}</div>
              <div>{{ boothAddress.data.firma2 }}</div>
              <div
                v-if="
                  boothAddress.data.adresseTyp == 'APADR' ||
                    boothAddress.data.adresseTyp == 'EADR'
                "
              >
                <div>
                  <span
                    v-if="
                      boothAddress.data.anrede === 'H' ||
                        boothAddress.data.anrede === 'F'
                    "
                    >{{
                      $t('global.salutation.' + boothAddress.data.anrede)
                    }} </span
                  >{{ boothAddress.data.vorname }}
                  {{ boothAddress.data.nachname }}
                </div>
              </div>
              <div>{{ boothAddress.data.strasse1 }}</div>
              <div>{{ boothAddress.data.plz }} {{ boothAddress.data.ort }}</div>
            </div>
          </div>
          <div class="o-grid__cell" style="padding-left: 0">
            <div
              v-if="boothCorrespondenceAddress.data !== undefined"
              class="address"
            >
              <div class="bold">
                {{ $t('fair.header.boothDetail.correspondenceAddress') }}:
              </div>
              <div>{{ boothCorrespondenceAddress.data.firma1 }}</div>
              <div>{{ boothCorrespondenceAddress.data.firma2 }}</div>
              <div
                v-if="
                  boothCorrespondenceAddress.data.adresseTyp == 'APADR' ||
                    boothCorrespondenceAddress.data.adresseTyp == 'EADR'
                "
              >
                <div>
                  <span
                    v-if="
                      boothCorrespondenceAddress.data.anrede === 'H' ||
                        boothCorrespondenceAddress.data.anrede === 'F'
                    "
                    >{{
                      $t(
                        'global.salutation.' +
                          boothCorrespondenceAddress.data.anrede
                      )
                    }} </span
                  >{{ boothCorrespondenceAddress.data.vorname }}
                  {{ boothCorrespondenceAddress.data.nachname }}
                </div>
              </div>
              <div>{{ boothCorrespondenceAddress.data.strasse1 }}</div>
              <div>
                {{ boothCorrespondenceAddress.data.plz }}
                {{ boothCorrespondenceAddress.data.ort }}
              </div>
            </div>
          </div>
          <div class="o-grid__cell" style="padding-left: 0">
            <div class="bold">{{ $t('fair.header.boothDetail.booth') }}:</div>
            <div>
              <span class="bold"
                >{{ $t('fair.header.boothDetail.displaytext') }}:</span
              >
              <span> {{ booth.blendentext }}</span>
            </div>
            <div>
              <span class="bold">{{ $t('fair.header.boothDetail.hall') }}:</span>
              {{ booth.halleBezeichnung }}
            </div>
            <div>
              <span class="bold">{{ $t('fair.header.boothDetail.boothnumber') }}:</span>
              {{ booth.standnummer }}
            </div>
            <div>
              <span class="bold">{{ $t('fair.header.boothDetail.area') }}:</span>
              <span v-if="booth.flaecheBrutto">
                {{ booth.flaecheBrutto }}m<sup>2</sup></span
              >
              <span v-else> -</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="header-exhibitor-type"
        v-if="(booth.ausstellerTyp !== undefined || isNewBooth()) && !minimized"
      >
        <div v-if="booth.ausstellerTyp !== undefined">
          <img
            v-if="booth.ausstellerTyp === 'AUSSTELLER'"
            src="@/assets/images/icons/aussteller_black.svg"
          />
          <img
            v-if="booth.ausstellerTyp !== 'AUSSTELLER'"
            src="@/assets/images/icons/mitaussteller_black.svg"
          />
          {{ $t('fair.header.standType.' + booth.ausstellerTyp) }}
        </div>
      </div>
      <div class="header-toggle">
        <bos-button @click.prevent="minimized = !minimized" ghost v-if="!minimized">{{ $t('fair.header.toggle.showLess') }}
          <template #icon>
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" width="34" height="34">
              <g id="Layer 1">
                <path id="Layer" fill-rule="evenodd" class="s0" d="m0.5 22.5h7.1l2.9-5.4 3 5.4h7l-6.3-11h-7.4z"/>
              </g>
            </svg>
          </template>
        </bos-button>
        <bos-button @click.prevent="minimized = !minimized" v-else>{{ $t('fair.header.toggle.showMore') }}
          <template #icon>
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 20" width="21" height="20">
              <g id="Layer 1">
                <path id="Layer" fill-rule="evenodd" class="s0" d="m20.5 4.5h-7.1l-2.9 5.4-3-5.4h-7l6.3 11h7.4l6.3-11z"/>
              </g>
            </svg>
          </template>
        </bos-button>

      </div>
    </div>
  </section>
</template>

<script>
import BosButton from '@/components/BosButton'
import ApiService from '@/services/ApiService'

export default {
  name: 'FairHeader',
  props: {
    fair: {
      type: Object,
      required: true,
      default: () => ({})
    },
    boothId: String,
    boothData: {
      type: Object,
      default: () => {}
    },
    boothAddress: {
      type: Object,
      default: () => {}
    },
    boothCorrespondenceAddress: {
      type: Object,
      default: () => {}
    },
    shops: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      minimized: false,
    }
  },
  computed: {
    booth() {
      if (this.boothId === 'new') {
        return {}
      }
      if (this.fair.booths === undefined) {
        return {}
      }
      let retVal = this.fair.booths.find(booth => booth.regiNr == this.boothId)
      if (retVal.status === 'OP') {
        return {
          status: 'OP',
          placeNum: retVal.placeNum,
          halleBezeichnung: retVal.halleBezeichnung,
          standnummer: retVal.standnummer,
          flaecheBrutto: retVal.flaecheBrutto,
          blendentext: retVal.blendentext
        }
      }
      retVal.placeNum = '- missing -'
      return retVal
    }
  },
  methods: {
    isNewBooth() {
      return this.$route.params.booth === 'new' || this.booth.status === 'OP'
    },
    getLogoUrl() {
      let currentLang = this.$store.getters['ui/getLocale'].substring(0, 2);
      return (process.env.VUE_APP_HEROKU_API_BASE_URL || process.env.VUE_APP_APIPATH) + 'fairs/logo/' + currentLang + '/' + this.fair.idCode;
    }
  },
  components: {
    BosButton
  }
}
</script>

<style scoped lang="scss">
$fairheader-margin: 0 0 2.25rem !default;

$fairheader-logo-margin: 0 0 0 1em !default;
$fairheader-logo-max-width: 200px !default;
$fairheader-mobile-logo-margin: 0 auto 2em !default;
$fairheader-mobile-logo-max-width: 180px !default;

$fairheader-action-margin: 0 !default;
$fairheader-mobile-action-margin: 1em 0 0 !default;

.fair-header {
  h2 {
    margin-bottom: 0;
  }

  margin: $fairheader-margin;
  position: relative;

  .header-toggle {
    text-align: center;
    padding-top: 10px;
  }

  &:after {
    display: block;
    content: '';
    clear: both;
  }

  .header-logo {
    float: right;
    margin: $fairheader-logo-margin;
    max-width: $fairheader-logo-max-width;

    img {
      display: block;
      width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .header-info {
    overflow: hidden;

    &__flex {
      display: flex;
      justify-content: space-between;
    }

    *:first-child {
      margin-top: 0;
    }

    .header-stand {
      margin-top: 1em;
    }

    .header-title {
      margin-bottom: 0;
    }

    .header-exhibitor-type {
      margin-top: 1.4em;

      img {
        margin-right: 10px;
      }
    }
  }

  .header-action {
    margin: $fairheader-action-margin;
    position: absolute;

    left: 0;
    bottom: 0;
    right: 0;
  }

  .md &,
  .sm &,
  .xs & {
    .header-logo {
      float: none;
      margin: $fairheader-mobile-logo-margin;
      max-width: $fairheader-mobile-logo-max-width;
    }

    .header-info {
      overflow: visible;
    }

    .header-action {
      float: none;
      margin: $fairheader-mobile-action-margin;
      position: inherit;
    }
  }
}

.address {
  padding-bottom: 1rem;
}

.bold {
  font-weight: bold;
}
</style>
